var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 21.9999C13.0672 21.4494 14.1076 21.596 14.6613 22.3263L14.669 22.3362C14.6789 22.3487 14.6978 22.3722 14.7253 22.405C14.7806 22.4709 14.8701 22.5736 14.9922 22.7009C15.2377 22.9571 15.6066 23.3046 16.0843 23.652C17.0461 24.3515 18.3757 24.9999 19.9998 24.9999C21.6239 24.9999 22.9536 24.3515 23.9154 23.652C24.3931 23.3046 24.762 22.9571 25.0075 22.7009C25.1295 22.5736 25.2191 22.4709 25.2743 22.405C25.3019 22.3722 25.3207 22.3487 25.3307 22.3362L25.3384 22.3263C25.892 21.596 26.9324 21.4494 27.6665 21.9999C28.4029 22.5522 28.5521 23.5969 27.9998 24.3333L26.6665 23.3333C27.9998 24.3333 28.0002 24.3327 27.9998 24.3333L27.9981 24.3355L27.9962 24.3381L27.9917 24.3441L27.9796 24.3598L27.9441 24.4052C27.9154 24.4415 27.8765 24.4897 27.8276 24.5479C27.7298 24.6644 27.5915 24.8221 27.4141 25.0073C27.0606 25.3761 26.5441 25.8619 25.8759 26.3478C24.5461 27.315 22.5424 28.3333 19.9998 28.3333C17.4573 28.3333 15.4536 27.315 14.1237 26.3478C13.4556 25.8619 12.939 25.3761 12.5856 25.0073C12.4082 24.8221 12.2698 24.6644 12.1721 24.5479C12.1232 24.4897 12.0843 24.4415 12.0555 24.4052L12.02 24.3598L12.008 24.3441L12.0034 24.3381L12.0015 24.3355C12.0011 24.335 11.9998 24.3333 13.3332 23.3333L11.9998 24.3333C11.4475 23.5969 11.5968 22.5522 12.3332 21.9999Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 14.9998C13.3332 14.0794 14.0794 13.3332 14.9998 13.3332H15.0165C15.937 13.3332 16.6832 14.0794 16.6832 14.9998C16.6832 15.9203 15.937 16.6665 15.0165 16.6665H14.9998C14.0794 16.6665 13.3332 15.9203 13.3332 14.9998Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 13.3332C24.0794 13.3332 23.3332 14.0794 23.3332 14.9998C23.3332 15.9203 24.0794 16.6665 24.9998 16.6665H25.0165C25.937 16.6665 26.6832 15.9203 26.6832 14.9998C26.6832 14.0794 25.937 13.3332 25.0165 13.3332H24.9998Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 1.6665C9.87462 1.6665 1.6665 9.87462 1.6665 19.9998C1.6665 30.1251 9.87462 38.3332 19.9998 38.3332C30.1251 38.3332 38.3332 30.1251 38.3332 19.9998C38.3332 9.87462 30.1251 1.6665 19.9998 1.6665ZM4.99984 19.9998C4.99984 11.7156 11.7156 4.99984 19.9998 4.99984C28.2841 4.99984 34.9998 11.7156 34.9998 19.9998C34.9998 28.2841 28.2841 34.9998 19.9998 34.9998C11.7156 34.9998 4.99984 28.2841 4.99984 19.9998Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.2908,
    y1: -11.7197,
    x2: 19.9998,
    y2: 38.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.2908,
    y1: -11.7197,
    x2: 19.9998,
    y2: 38.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 20.2908,
    y1: -11.7197,
    x2: 19.9998,
    y2: 38.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 20.2908,
    y1: -11.7197,
    x2: 19.9998,
    y2: 38.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.4a6597a5.svg";
export { ForwardRef as ReactComponent };